/**
 * @module state/history
 * Expose the session history as an importable thing.
 * @see {@link https://github.com/ReactTraining/history}
 */

import {createHashHistory} from "history";
export const history        = createHashHistory();



// WEBPACK FOOTER //
// ./src/state/history.js